import styled from 'styled-components'

import { TextField } from '@radix-ui/themes'

/* https://github.com/radix-ui/themes/issues/527 */
export const TextFieldRootUnsetWhitespace = styled(TextField.Root)`
    input[type='date'] {
        white-space: unset;
    }

    .rt-TextFieldSlot {
        padding-inline: 0 !important;
    }

    .rt-variant-ghost {
        height: var(--base-button-height);
        width: var(--base-button-height);
        margin: 0;
    }
`
